import { chameleonSvg } from '../../Svg';
import { provideChameleonDesignSystem } from '../../provideChameleonDesignSystem';
import { chameleonDataTableHeaderCellV2 } from './DataTableHeaderCellV2.definition';
import { chameleonTypography } from '../../Typography/Typography.definition';
export function registerCustom(prefix, node) {
    return provideChameleonDesignSystem({ prefix, node }).register(chameleonTypography({ prefix }), chameleonDataTableHeaderCellV2({ prefix }), chameleonSvg({ prefix }));
}
